// Маршруты лендинга v3. Маршруты старого кабинета — в router.legacy.ts (в сборку не входят).
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', name: 'home', component: () => import('@/page/landing_v3/page/home.vue') },
  { path: '/info/:slug', name: 'info', component: () => import('@/page/landing_v3/page/info.vue') },
  // Публичная страница ассета: /asset/{slug}-{id} и короткая /{id}; id разбирается в assetApi.js
  { path: '/asset/:path', name: 'asset', component: () => import('@/page/landing_v3/page/asset.vue') },
  { path: '/:id(\\d+)', name: 'asset-short', component: () => import('@/page/landing_v3/page/asset.vue') },
  // ВРЕМЕННО: диагностика шапки во встроенном браузере Telegram на iOS, удалить вместе с vp-test.vue
  { path: '/vp-test', name: 'vp-test', component: () => import('@/page/landing_v3/page/vp-test.vue') },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/page/landing_v3/page/not-found.vue') },
]

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // Прокручивается контейнер #app, а не window (см. landing.css): к верху новой страницы — вручную
  scrollBehavior: () => { document.getElementById('app')?.scrollTo(0, 0); return false },
  routes,
})
